/**
 * Cross-component request to open AppTrekPackages' package modal
 * (e.g. map-page "Check dates" → same modal as clicking a package card).
 */
export function useOpenTrekPackageModal() {
  const request = useState<{
    packageId?: string | number | null;
    packageTitle?: string | null;
    /** When true, switch the packages year toggle to year 2 (e.g. 2027) if available. */
    preferYear2?: boolean;
    nonce: number;
  } | null>("open-trek-package-modal", () => null);

  function requestOpenPackageModal(options: {
    packageId?: string | number | null;
    packageTitle?: string | null;
    preferYear2?: boolean;
  }) {
    request.value = {
      packageId: options.packageId ?? null,
      packageTitle: options.packageTitle ?? null,
      preferYear2: options.preferYear2 ?? false,
      nonce: Date.now(),
    };
  }

  function clearOpenPackageModalRequest() {
    request.value = null;
  }

  return {
    request,
    requestOpenPackageModal,
    clearOpenPackageModalRequest,
  };
}
